const containerClassesByPropName = {
  incident_description: "md:col-span-12",
};

const moduleInputProps = {
  incident_description: { isTextarea: true },
};

const moduleProps = {
  incident_type: { typeProperties: { searchable: true } },
  incident_role: { typeProperties: { searchable: true } },
  incident_city: { typeProperties: { searchable: true } },
  incident_location: { typeProperties: { searchable: true } },
};

export { containerClassesByPropName, moduleInputProps, moduleProps };
